export default __webpack_public_path__ + "static/celebrate80x80-312253902f972625e273559d924e147c.svg";